/**
 * 微信端
 */
import { getUrlArg, urlParamToJson } from "@utils/urlUtil";
import { plat, isAppletEnvi } from "@utils/plat";
import { getLocalAuthUrl } from "../public/utils";
import { DEFAULT_AVATAR, DEFAULT_NICK } from "../public/constant";
import Cookie from "js-cookie";

let storageKey = "activity";
/**
 * 微信授权
 * @param {string[]} searchArgs search参数
 * @param {boolean} isGetUserInfo 是否获取用户信息
 * @param {boolean} isHash 是否需要解析hash
 * @return {Promise<Record<string, string>} 返回用户信息
 */
export async function getAuth({ searchArgs, isGetUserInfo, isHash, key }) {
    // 授权key
    if (key) storageKey = key;

    let wxUser = urlParamToJson(Cookie.get("WxUser") || "");

    // 获取名称
    const nick = getUrlArg("nickname") || DEFAULT_NICK;
    // 获取头像
    const avatar = getUrlArg("imgurl") || DEFAULT_AVATAR;
    // 获取openid
    const code = getUrlArg("openid") || getUrlArg("code") || wxUser.openid;
    // 获取unionid
    const unionid = wxUser.unionid || "";
    // 获取缓存
    let store = JSON.parse(localStorage.getItem(storageKey) || "{}");
    // 判断是否存在code
    if (code) {
        try {
            nick = decodeURIComponent(nick.replace(/\%\@/g, ""));
        } catch (error) {}
        // 替换
        store = {
            code,
            avatar,
            nick,
            unionid
        };
        localStorage.setItem(storageKey, JSON.stringify(store));
    }
    // 挂载
    const isApplet = await mounted(store, searchArgs, isGetUserInfo, isHash);
    return {
        userInfo: store,
        isApplet
    };
}
/**
 * 获取openid
 * @param {Record<string, string} store 状态
 * @param {string[]} searchArg search参数
 * @param {boolean} isGetUserInfo 是否获取用户信息
 * @param {boolean} isHash 是否需要解析hash
 */
function mounted(store, searchArg = ["refid"], isGetUserInfo = false, isHash = false) {
    return new Promise(resolve => {
        // 存在则挂载
        if (store.nick && store.code) {
            // 判断渠道
            isAppletEnvi(isApplet => {
                resolve(isApplet);
            });
        } else {
            // 获取授权链接
            const authUrl = getLocalAuthUrl(plat.wx.id, searchArg, false, isGetUserInfo, isHash);
            location.replace(authUrl);
        }
    });
}
